{
  "name": "app",
  "version": "9.4.11",
  "author": "kilobyteLAB",
  "homepage": "https://kilobytelab.com/",
  "scripts": {
    "start": "ionic s -p8102 --no-open",
    "prod": "ionic s -p8102 --prod --no-open",
    "deploy": "ionic build --prod && gulp deployprod",
    "dev": "ionic build --configuration=development && gulp deploydev"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "catalog:angular",
    "@angular/core": "catalog:angular",
    "@angular/forms": "catalog:angular",
    "@angular/platform-browser": "catalog:angular",
    "@angular/router": "catalog:angular",
    "@angular/service-worker": "catalog:angular",
    "@ionic/angular": "catalog:ionic",
    "@kilobytelab/core": "workspace:*",
    "@kilobytelab/domain": "workspace:*",
    "@kilobytelab/types": "workspace:*",
    "@ng-icons/core": "catalog:icons",
    "@ng-icons/material-icons": "catalog:icons",
    "@ng-icons/tabler-icons": "catalog:icons",
    "@ngx-pwa/local-storage": "catalog:utils",
    "big.js": "catalog:utils",
    "firebase": "catalog:firebase",
    "html-to-image": "catalog:utils",
    "ionicons": "catalog:icons",
    "luxon": "catalog:utils",
    "ngx-quill": "catalog:quill",
    "quill": "catalog:quill",
    "recaptcha-v3": "catalog:ui",
    "rxjs": "catalog:utils",
    "signature_pad": "catalog:ui",
    "swiper": "catalog:ui"
  },
  "devDependencies": {
    "@angular/build": "catalog:angular",
    "@angular/cli": "catalog:angular",
    "@angular/compiler": "catalog:angular",
    "@angular/compiler-cli": "catalog:angular",
    "@angular/language-service": "catalog:angular",
    "@ionic/angular-toolkit": "catalog:ionic",
    "@types/big.js": "catalog:utils",
    "@types/downloadjs": "catalog:utils",
    "@types/luxon": "catalog:utils",
    "@types/quill": "catalog:quill",
    "gulp": "catalog:gulp",
    "tslib": "catalog:dev",
    "typescript": "catalog:dev"
  },
  "description": "Agenda Digital BabyCloud"
}